import React from 'react'

import { updateAnswer } from 'store/actions'
import { useQuizContext } from 'store/QuizStore'
import { FluidBox, ResultLink, HintWrapper, OptionButtonInner } from 'styled'

import { Root, Options, ListButton } from './ListQuestion.styled.js'

const ListQuestion = ({
  options,
  answer,
  answerInfo,
  answerType,
  visited,
  entering,
  leaving,
  navDirection,
}) => {
  const { dispatch } = useQuizContext()

  const setAnswer = id => {
    if (answerType === 'single') {
      updateAnswer(dispatch, id)
    } else {
      const a = answer ? [...answer] : new Array(options.length)
      a[id] = !a[id]
      updateAnswer(dispatch, a)
    }
  }

  const isSelected = id => {
    return answer === null ? false : answerType === 'single' ? answer === id : answer[id]
  }

  return (
    <Root visited={visited}>
      <Options py="spaceNormal">
        {options.map((option, id) => (
          <ListButton
            key={id}
            nth={id}
            wrapped={options.length > 5}
            selected={isSelected(id)}
            onClick={() => setAnswer(id)}
            single={answerType === 'single'}
            entering={entering}
            leaving={leaving}
            navDirection={navDirection}
          >
            <OptionButtonInner selected={isSelected(id)}>{option}</OptionButtonInner>
          </ListButton>
        ))}
      </Options>
      <HintWrapper entering={entering} leaving={leaving} navDirection={navDirection}>
        {!visited ? (
          <FluidBox fs="textSmall" color="darkGrey" mb="spaceNormal">
            Select one of the options
          </FluidBox>
        ) : (
          <ResultLink
            href={answerInfo.source.url || null}
            as={answerInfo.source.url ? 'a' : 'div'}
            target={answerInfo.source.url ? '_blank' : undefined}
            rel="noopener noreferrer"
            fs={12}
            align="center"
            color="primary"
            mb="spaceNormal"
          >
            {answerInfo.source.text}
          </ResultLink>
        )}
      </HintWrapper>
    </Root>
  )
}

export default ListQuestion
